/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function _addMeToCart(e, el) {
	e = e || window.event
	e.preventDefault()

	let formData = {
		items: [
			{
				id: el.dataset.variant_id,
				quantity: 1,
			},
		],
	}

	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(formData),
	})
		.then((resp) => {
			return resp.json()
		})
		.then((data) => {
			document.documentElement.dispatchEvent(
				new CustomEvent('cart:refresh', {
					bubbles: true,
				})
			)
		})
		.catch((err) => {
			console.error('Error: ' + err)
		})
}

document.addEventListener('cart:refresh', function (event) {
	let itemQty = document.querySelector('.Header__CartDot ')
	fetch(window.Shopify.routes.root + 'cart.js')
		.then((response) => response.json())
		.then((data) => {
			itemQty.innerHTML = data.item_count
		})
})
